import { render, staticRenderFns } from "./IncomeDetails.vue?vue&type=template&id=562d11a3&scoped=true&"
import script from "./IncomeDetails.vue?vue&type=script&lang=js&"
export * from "./IncomeDetails.vue?vue&type=script&lang=js&"
import style0 from "./IncomeDetails.vue?vue&type=style&index=0&id=562d11a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562d11a3",
  null
  
)

export default component.exports